import { watchAuth } from './auth/sagas';

const watchers = [
    watchAuth
];

export default watchers;